import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useAuthContext } from '../../../contexts/authContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { validatePermission } from '../../../services/auth.service';

type Props = {
    route?: string | undefined;
    label: string;
    icon: JSX.Element | string;
    subItems?: any[];
    open?: boolean | undefined;
    type: string;
};

const Sidebar = ({ route, label, icon, subItems, open, type }: Props) => {
    const navigate = useNavigate();
    const { channel } = useAuthContext();
    const { channelList } = useSelector((state: RootState) => state.general);
    const [openItems, setOpenItems] = useState(false);

    const handleClickItems = () => {
        setOpenItems(!openItems);
    };

    return (
        <>
            <ListItem key={label} disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                    onClick={() =>
                        route ? navigate(route) : handleClickItems()
                    }
                    sx={{
                        justifyContent: open ? 'initial' : 'center',
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: 0,
                            mr: open ? 1.5 : 'auto',
                            justifyContent: 'center',
                        }}
                    >
                        {icon}
                    </ListItemIcon>
                    <ListItemText
                        primary={label}
                        sx={{ opacity: open ? 1 : 0 }}
                    />
                    {subItems ? (
                        openItems ? (
                            <ExpandLess fontSize="small" />
                        ) : (
                            <ExpandMore fontSize="small" />
                        )
                    ) : null}
                </ListItemButton>
            </ListItem>
            <Collapse in={openItems} timeout="auto" unmountOnExit>
                <List disablePadding>
                    {subItems?.map(
                        ({ route, label, icon, permissions }) =>
                            (!permissions ||
                                validatePermission(
                                    permissions,
                                    channelList,
                                    type,
                                    channel
                                )) && (
                                <ListItem
                                    key={label}
                                    disablePadding
                                    sx={{ display: 'block' }}
                                >
                                    <ListItemButton
                                        onClick={() => navigate(route)}
                                        sx={{
                                            pl: 3,
                                            justifyContent: open
                                                ? 'initial'
                                                : 'center',
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: 0,
                                                mr: open ? 1.5 : 'auto',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={label}
                                            sx={{ opacity: open ? 1 : 0 }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            )
                    )}
                </List>
            </Collapse>
        </>
    );
};

export default Sidebar;
